import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import axios from 'axios';

// Plugins
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import i18n from './i18n';
import toastPlugin from './plugins/toast';

// Components - Layout
import MainLayout from './components/layout/MainLayout.vue';
import Header from './components/layout/Header.vue';

// Components - Features
import StandingsTable from './components/features/standings/StandingsTable.vue';
import ResultsTable from './components/features/calendar/ResultsTable.vue';
import GameCard from './components/features/calendar/GameCard.vue';

// Configure axios: credentials + Laravel XSRF cookie (survives session regenerate without full reload)
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// Обработка ошибки 419 (Page Expired) - перезагружаем страницу
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 419) {
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

window.axios = axios;

const appName = 'Волейбол Беларуси';

createInertiaApp({
    title: (title) => title || appName,
        resolve: (name) => {
        return require(`./Pages/${name}.vue`).default;
        },
        setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(i18n)
            .use(toastPlugin);
            
            // Register global components
            app.component('main-layout', MainLayout);
            app.component('header-component', Header);
            app.component('standings-table', StandingsTable);
            app.component('results-table', ResultsTable);
            app.component('game-card', GameCard);
            
            app.mount(el);
            return app;
        },
        progress: {
        color: '#275092',
        },
    });
